// extracted by mini-css-extract-plugin
export default {"auth_content":"Auth_auth_content__uQgQf","auth_register":"Auth_auth_register__AIFim","auth_title":"Auth_auth_title__nUDw9"};